import { render } from "./Articles.vue?vue&type=template&id=347c0b24"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=347c0b24&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Articles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "347c0b24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('347c0b24', __exports__)) {
    api.reload('347c0b24', __exports__)
  }
  
  module.hot.accept("./Articles.vue?vue&type=template&id=347c0b24", () => {
    api.rerender('347c0b24', render)
  })

}


export default __exports__